import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserDetails } from "../utils/authService";
export const fetchUserDetails = createAsyncThunk(
    "user/fetchUserDetails",
    async ({token,userId}, { rejectWithValue }) => {
        try {
            const userData = await getUserDetails(token,userId);


            return {
                isAdmin: userData?.permissions?.includes("admin:access"), // ✅ Check for admin permission
                details: userData || {},
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
const userSlice = createSlice({
    name: "user",
    initialState: {
        isAdmin: false,
        details: null,
        status: "idle", // "idle" | "loading" | "succeeded" | "failed"
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserDetails.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchUserDetails.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.isAdmin = action.payload.isAdmin;
                state.details = action.payload.details;
            })
            .addCase(fetchUserDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export default userSlice.reducer;